import axios from "axios";
import { looupCountryDropdownSlice } from "../../slice/stations/getLookupCountryListSlice";
import apiHeader from "../../../Components/ApiHeader";

const { actions } = looupCountryDropdownSlice;

export const lookUpCountryDropdownAPI: any =
  ({ ApiUrl, Type, params }: any) =>
  (dispatch: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);

    axios
      .get(ApiUrl, {
        params: params,
        // headers: {
        //   token: JSON.parse(token),
        // },
        headers: commonHead,
      })
      .then((response) => {
        const { data } = response;
        dispatch(actions.getCountryDropData({ type: Type, data }));
      })
      .catch((err) => {
        dispatch(
          actions.getCountryDropData({ type: "error", paylod: err.message })
        );
      });
  };
